<template>
  <v-row justify="start">
    <v-col v-if="legend.includes('not-exact')" cols="auto">
      <v-icon size="20" color="red">mdi-alert-octagram-outline</v-icon>
      <span style="font-size: 13px; color: red">{{ mess.legend_not_exact }}</span>
    </v-col>

    <v-col v-if="legend.includes('assembly')" cols="auto">
      <v-icon size="18">widgets</v-icon>
      <span style="font-size: 13px">{{ mess.legend_assembly }}</span>
    </v-col>

    <v-col v-if="legend.includes('have-analog')" cols="auto">
      <v-icon size="18">mdi-content-copy</v-icon>
      <span style="font-size: 13px">{{ mess.legend_analog }}</span>
    </v-col>

    <v-col v-if="legend.includes('on-store')" cols="auto">
      <v-icon size="19">mdi-warehouse</v-icon>
      <span style="font-size: 13px">{{ mess.legend_item_on_store }}</span>
    </v-col>

    <v-col v-if="legend.includes('analog-on-store')" cols="auto">
      <v-icon size="19">mdi-check-box-multiple-outline</v-icon>
      <span style="font-size: 13px">{{ mess.legend_analog_on_store }}</span>
    </v-col>

    <v-col v-if="legend.includes('in-transit')" cols="auto">
      <v-icon size="19">mdi-ferry</v-icon>
      <span style="font-size: 13px">{{ mess.legend_transit }}</span>
    </v-col>

    <v-col v-if="legend.includes('sales-draw')" cols="auto">
      <v-icon size="19">mdi-android-studio</v-icon>
      <span style="font-size: 13px">{{ mess.legend_sales_draft }}</span>
    </v-col>

    <v-col v-if="legend.includes('file')" cols="auto">
      <v-icon size="19" style="transform: rotate(90deg)">mdi-attachment</v-icon>
      <span style="font-size: 13px">{{ mess.legend_file }}</span>
    </v-col>

    <v-col v-if="legend.includes('reference')" cols="auto" :title="mess['reference']">
      <v-row style="margin: 3px 0 0;">
        <svg width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.5 14.25C2.2536 14.2507 2.00951 14.2024 1.78186 14.1081C1.55421 14.0138 1.34752 13.8753 1.17375 13.7006L0.208752 12.8419C0.0849286 12.7315 0.0100319 12.5764 0.000537856 12.4108C-0.00895617 12.2452 0.0477302 12.0826 0.158127 11.9588C0.268523 11.8349 0.423586 11.76 0.589204 11.7505C0.754822 11.741 0.917429 11.7977 1.04125 11.9081L2.03188 12.7919C2.08859 12.8556 2.15773 12.907 2.23505 12.9429C2.31237 12.9789 2.39623 12.9987 2.48147 13.001C2.56672 13.0033 2.65154 12.9882 2.73072 12.9566C2.80989 12.9249 2.88176 12.8774 2.94188 12.8169L5.19188 10.6725C5.25065 10.6127 5.32084 10.5654 5.39828 10.5333C5.47571 10.5012 5.55882 10.485 5.64264 10.4857C5.72646 10.4864 5.80928 10.5039 5.88619 10.5373C5.96309 10.5706 6.0325 10.6191 6.09029 10.6798C6.14807 10.7406 6.19306 10.8123 6.22256 10.8907C6.25205 10.9692 6.26547 11.0528 6.262 11.1365C6.25854 11.2203 6.23826 11.3025 6.20237 11.3783C6.16649 11.454 6.11573 11.5218 6.05313 11.5775L3.8125 13.7113C3.63986 13.8829 3.43508 14.0188 3.20987 14.1113C2.98466 14.2037 2.74344 14.2508 2.5 14.25ZM14.375 13.625H8.125C7.95924 13.625 7.80027 13.5592 7.68306 13.4419C7.56585 13.3247 7.5 13.1658 7.5 13C7.5 12.8342 7.56585 12.6753 7.68306 12.5581C7.80027 12.4409 7.95924 12.375 8.125 12.375H14.375C14.5408 12.375 14.6997 12.4409 14.8169 12.5581C14.9342 12.6753 15 12.8342 15 13C15 13.1658 14.9342 13.3247 14.8169 13.4419C14.6997 13.5592 14.5408 13.625 14.375 13.625ZM2.5 9.25C2.2536 9.25065 2.00951 9.20243 1.78186 9.10813C1.55421 9.01383 1.34752 8.87533 1.17375 8.70063L0.183127 7.71C0.0692778 7.59213 0.00628124 7.43425 0.00770526 7.27038C0.00912927 7.1065 0.0748599 6.94975 0.19074 6.83387C0.30662 6.71799 0.463378 6.65226 0.627251 6.65083C0.791124 6.64941 0.949 6.7124 1.06688 6.82625L2.05813 7.81688C2.17711 7.93065 2.33538 7.99414 2.5 7.99414C2.66462 7.99414 2.8229 7.93065 2.94188 7.81688L5.19188 5.6725C5.31189 5.55796 5.47248 5.49579 5.63834 5.49966C5.80419 5.50352 5.96171 5.57312 6.07625 5.69313C6.19079 5.81314 6.25297 5.97373 6.2491 6.13959C6.24523 6.30544 6.17564 6.46296 6.05563 6.5775L3.8125 8.71125C3.63986 8.88289 3.43508 9.01881 3.20987 9.11126C2.98466 9.2037 2.74344 9.25085 2.5 9.25ZM14.375 8.625H8.125C7.95924 8.625 7.80027 8.55916 7.68306 8.44195C7.56585 8.32473 7.5 8.16576 7.5 8C7.5 7.83424 7.56585 7.67527 7.68306 7.55806C7.80027 7.44085 7.95924 7.375 8.125 7.375H14.375C14.5408 7.375 14.6997 7.44085 14.8169 7.55806C14.9342 7.67527 15 7.83424 15 8C15 8.16576 14.9342 8.32473 14.8169 8.44195C14.6997 8.55916 14.5408 8.625 14.375 8.625ZM2.5 4.25C2.2536 4.25065 2.00951 4.20243 1.78186 4.10813C1.55421 4.01383 1.34752 3.87533 1.17375 3.70063L0.208752 2.84188C0.0849286 2.73148 0.0100319 2.57642 0.000537856 2.4108C-0.00895617 2.24518 0.0477302 2.08258 0.158127 1.95875C0.268523 1.83493 0.423586 1.76003 0.589204 1.75054C0.754822 1.74105 0.917429 1.79773 1.04125 1.90813L2.03188 2.79188C2.08859 2.85556 2.15773 2.90697 2.23505 2.94293C2.31237 2.9789 2.39623 2.99866 2.48147 3.001C2.56672 3.00334 2.65154 2.98822 2.73072 2.95655C2.80989 2.92489 2.88176 2.87735 2.94188 2.81688L5.19438 0.672504C5.3155 0.564673 5.47379 0.508141 5.63582 0.514848C5.79784 0.521556 5.95092 0.590977 6.06272 0.708451C6.17451 0.825924 6.23627 0.98225 6.23494 1.14441C6.23362 1.30657 6.16932 1.46187 6.05563 1.5775L3.8125 3.71125C3.63986 3.88289 3.43508 4.01882 3.20987 4.11126C2.98466 4.2037 2.74344 4.25085 2.5 4.25ZM14.375 3.625H8.125C7.95924 3.625 7.80027 3.55916 7.68306 3.44195C7.56585 3.32474 7.5 3.16576 7.5 3C7.5 2.83424 7.56585 2.67527 7.68306 2.55806C7.80027 2.44085 7.95924 2.375 8.125 2.375H14.375C14.5408 2.375 14.6997 2.44085 14.8169 2.55806C14.9342 2.67527 15 2.83424 15 3C15 3.16576 14.9342 3.32474 14.8169 3.44195C14.6997 3.55916 14.5408 3.625 14.375 3.625Z" fill="#808080"/>
        </svg>

        <span class="ml-2" style="font-size: 13px">{{ mess.legend_reference }}</span>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ArticleLegend",
  props: {
    legend: {
      type: Array,
      default: () => [
        "assembly",
        "have-analog",
        "on-store",
        "analog-on-store",
        "in-transit",
        "sales-draw",
        "reference"
      ]
    }
  }
};
</script>

<style lang="scss" scoped></style>
